module.exports = __webpack_public_path__ + "img/af.d625b8f3.png";